export default {
  'component.bookinspection.title': 'Book befaring',
  'component.bookinspection.description':
    'Når vi selger hjemmet ditt, er det lovpålagt at en av våre meglere kommer hjem til deg. Du bestiller tid for dette på denne siden. Megleren så kontakter du deg for å bekrefte klokkeslettet.',
  'component.bookinspection.line1':
    'Angi ønsket vindu for når du vil at megleren skal besøke deg. Minimumstidsvindu er 4 timer.',
};
